import React, { useEffect, useState } from 'react';
import Select from 'react-select';
import { useStateContext } from '../contexts/ContextProvider';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import axiosClient from '../axios-client';

const Langues = () => {
    const { setToken, user, setUser } = useStateContext();
    const [langues, setLangues] = useState([
        { code: 'AR', value: 'العربية', flag: <img src="https://flagcdn.com/16x12/mr.png" srcset="https://flagcdn.com/32x24/mr.png 2x, https://flagcdn.com/48x36/mr.png 3x"  width="16" height="12" alt="Mauritania"></img> },
        {
            code: 'FR', value: 'Français', flag: <img src="https://flagcdn.com/16x12/fr.png" srcset="https://flagcdn.com/32x24/fr.png 2x, https://flagcdn.com/48x36/fr.png 3x"  width="16" height="12" alt="France"></img>
        }
    ]);
    const [selectedLangue, setSelectedLangue] = useState(null);
    const [inputValueLangue, setValueLangue] = useState();
    const navigate = useNavigate();
    const [errors, setErrors] = useState(null);

    useEffect(() => {
        if (user.langue === 'FR') {
            setSelectedLangue(langues.find(l => l.code === 'FR'));
        } else if (user.langue === 'AR') {
            setSelectedLangue(langues.find(l => l.code === 'AR'));
        } else {
            setSelectedLangue(null);
        }
    }, [user.langue, langues]);

    const updateLangue = (code) => {
        axiosClient.put('/user/updateLangue/' + code)
            .then(() => {
                setErrors(null);
            }).catch(err => {
                const response = err.response;
                if (response.status === 401) {
                    setToken(null);
                }
                else if (response.status === 422) {
                    setErrors(response.data.errors);
                    toast.error('Une erreur est survenue!', {
                        position: "top-right",
                        autoClose: 5000,
                        theme: "light",
                    });
                } else if (response.status === 403) {
                    navigate('/403');
                } else if (response.status === 404) {
                    navigate('/404');
                } else {
                    navigate('/500');
                }
            });
    };

    const handleChangeLangue = (value) => {
        setSelectedLangue(value);
        setUser({ ...user, langue: value.code });
        updateLangue(value.code);
    };

    const handleInputChangeLangue = (value) => {
        setValueLangue(value);
    };

    return (
        <div >
            <Select
                className="outline-1 text-sm"
                placeholder="Langue"
                cacheOptions
                defaultOptions
                value={selectedLangue}
                options={langues}
                onInputChange={handleInputChangeLangue}
                onChange={handleChangeLangue}
                getOptionLabel={(e) => e.value}
                getOptionValue={(e) => e.code}
                formatOptionLabel={(option) => (
                    <div className="flex items-center gap-2">
                        <span className="text-lg">{option.flag}</span>
                        <span>{option.value}</span>
                    </div>
                )}
                styles={{
                    control: (base) => ({
                        ...base,
                        borderRadius: '8px',
                        padding: '2px',
                        borderColor: '#ddd',
                        boxShadow: 'none',
                        '&:hover': { borderColor: '#aaa' }
                    }),
                    option: (base, { isFocused }) => ({
                        ...base,
                        backgroundColor: isFocused ? '#f0f0f0' : 'white',
                        color: '#333',
                        cursor: 'pointer',
                    }),
                    singleValue: (base) => ({
                        ...base,
                        display: 'flex',
                        alignItems: 'center',
                        gap: '8px'
                    })
                }}
            />
        </div>
    );
};

export default Langues;
